import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import MobileSection from './MobileSection';
import ScannerConfiguration from './ScannerConfiguration';
import { connect } from 'react-redux';

// Utils
import { userRoles } from 'utils/constants';
import { VIRTUAL_GUARD } from 'utils/route-constants';

// Hooks
import { useLocation } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

// Components
import Profile from './Profile';
import NotificationBell from './NotificationBell';
import PropertySelector from 'components/Property/PropertySelector';
import { InvitationsButton } from 'components/Resi/Header/InvitationsButton';

const HeaderContent = ({ userData }) => {
    const matchesXs = useMediaQuery(theme => theme.breakpoints.down('md'));
    const location = useLocation();
    const { properties } = useAuth();

    const isVirtualGuardRoute = location.pathname === VIRTUAL_GUARD;

    const activeOrgId = userData?.active_org_id;
    const activeOrg = activeOrgId ? userData?.orgs?.[activeOrgId] : null;

    const isVirtualGuard =
        (userData?.role === 'operator' && userData?.type === 'virtual_guard') ||
        (Array.isArray(activeOrg?.permissions) &&
            activeOrg.permissions.includes('virtual_guard'));

    const userIsResiOrTenant =
        userData?.role === userRoles.RESIDENT || userData?.role === userRoles.TENANT;

    return (
        <>
            {!matchesXs && (
                // Same 22px spacing as the resident header (Resi/Header/TopNavigation).
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '22px' }}>
                    {isVirtualGuardRoute && isVirtualGuard && <ScannerConfiguration />}
                    {userIsResiOrTenant && properties && properties.length > 1 && (
                        <PropertySelector />
                    )}
                    <InvitationsButton />
                    <NotificationBell />
                    <Profile />
                </Box>
            )}

            {matchesXs && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ mr: 1 }}>
                        <InvitationsButton />
                    </Box>
                    <NotificationBell />
                    <MobileSection />
                </Box>
            )}
        </>
    );
};

const mapStateToProps = ({ user }) => {
    const { userData } = user;
    return { userData };
};

export default connect(mapStateToProps, {})(HeaderContent);
